/**
 * TL;DR block — 1-3 sentences at the top of content pages.
 *
 * Princeton GEO research: AI citation rate rises ~37% when an
 * extractable summary appears above the fold. The block must be short
 * enough to lift verbatim and the heading must literally read "TL;DR"
 * (or its localised equivalent) so extractors recognise the pattern.
 */

import type { ReactNode } from "react";

type Props = {
  /** Plain text summary — keep under 300 chars for maximum extraction */
  children: ReactNode;
  /** Localised label; defaults to "TL;DR" */
  label?: string;
};

export function Tldr({ children, label = "TL;DR" }: Props) {
  return (
    <aside
      role="doc-abstract"
      aria-label={label}
      className="rounded-md border border-border bg-muted/30 ps-4 pe-4 py-3 text-sm text-foreground"
    >
      <p className="font-semibold mb-1">{label}</p>
      <p>{children}</p>
    </aside>
  );
}
